<template>
  <path pid="0" d="M17.71 3.29A1 1 0 0017 3H6a3 3 0 00-3 3v14a3 3 0 003 3h14a3 3 0 003-3V9a1 1 0 00-.29-.71zM17 21H9v-6h8zm4-1a1 1 0 01-1 1h-1v-7a1 1 0 00-1-1H7.88A1 1 0 007 14v7H6a1 1 0 01-1-1V6a1 1 0 011-1h1v4a1 1 0 001 1h8a1 1 0 000-2H9V5h7.59L21 9.41z"/>
</template>
